import { render, staticRenderFns } from "./UploadBisnisLiniProduct.vue?vue&type=template&id=35634c66"
import script from "./UploadBisnisLiniProduct.vue?vue&type=script&lang=js"
export * from "./UploadBisnisLiniProduct.vue?vue&type=script&lang=js"
import style0 from "./UploadBisnisLiniProduct.vue?vue&type=style&index=0&id=35634c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports